function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.077 5.385a1 1 0 01-1 1H7a2 2 0 00-2 2V17a2 2 0 002 2h8.615a2 2 0 002-2v-6.077a1 1 0 112 0V17a4 4 0 01-4 4H7a4 4 0 01-4-4V8.385a4 4 0 014-4h6.077a1 1 0 011 1z",
  fill: "currentColor"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.308 12.692L21 3m0 0h-4.667M21 3v4.154",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC4wNzcgNS4zODVhMSAxIDAgMDEtMSAxSDdhMiAyIDAgMDAtMiAyVjE3YTIgMiAwIDAwMiAyaDguNjE1YTIgMiAwIDAwMi0ydi02LjA3N2ExIDEgMCAxMTIgMFYxN2E0IDQgMCAwMS00IDRIN2E0IDQgMCAwMS00LTRWOC4zODVhNCA0IDAgMDE0LTRoNi4wNzdhMSAxIDAgMDExIDF6IiBmaWxsPSJjdXJyZW50Q29sb3IiLz48cGF0aCBkPSJNMTEuMzA4IDEyLjY5MkwyMSAzbTAgMGgtNC42NjdNMjEgM3Y0LjE1NCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+PC9zdmc+";
export { SvgExpand as ReactComponent };